import React, { Component } from 'react';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import { ProductNameBox, Icon, LocaleLink } from '../../../common/';
import I18n from '../../../../i18n/I18n';
import Helper from '../../../../helper/Helper';
import styles from '../../../orders/orderTable/OrderTable.scss';

class ProductTable extends Component {
    state = { isPaneOpen: false };

    openModal = () => {
        this.setState({
            isPaneOpen: true,
        });
    };
    onCloseModal = () => {
        this.setState({
            isPaneOpen: false,
        });
    };

    render() {
        const { item, searchString, property, seller } = this.props;

        return (
            <tr className={styles.row}>
                {property.haveVal('psku_canonical') ? (
                    <td>
                        <a
                            target="_blank"
                            href={`${Helper.getAppDomain(
                                'catalog',
                            )}/${Helper.getLocale()}/catalog/${
                                item.psku_canonical
                            }`}
                        >
                            <ProductNameBox
                                data={item}
                                searchString={searchString}
                            />
                        </a>
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('item_nr') ? (
                    <td>
                        <Highlighter
                            highlightClassName={styles.highlight}
                            searchWords={[searchString]}
                            autoEscape={true}
                            textToHighlight={item.item_nr}
                        />
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('customer_country_code') ? (
                    <td>{item.customer_country_code}</td>
                ) : (
                    ''
                )}

                {property.haveVal('partner_sku_unique') ? (
                    <td>
                        {item.partner_sku_unique ? (
                            <Highlighter
                                highlightClassName={styles.highlight}
                                searchWords={[searchString]}
                                autoEscape={true}
                                textToHighlight={item.partner_sku_unique}
                            />
                        ) : (
                            ''
                        )}
                    </td>
                ) : (
                    ''
                )}
                {property.haveVal('sku') ? (
                    <td>
                        {item.sku ? (
                            <Highlighter
                                highlightClassName={styles.highlight}
                                searchWords={[searchString]}
                                autoEscape={true}
                                textToHighlight={item.sku}
                            />
                        ) : (
                            ''
                        )}
                    </td>
                ) : (
                    ''
                )}

                {property.haveVal('invoice_date') ? (
                    <td>
                        {item && item.invoice_date
                            ? moment(item.invoice_date).format(`YYYY-MM-DD`)
                            : '-'}
                    </td>
                ) : (
                    ''
                )}

                <td>
                    <div
                        className={`${styles.iconStatus} ${styles.status} ${
                            styles[item.status_code]
                        }`}
                    >
                        {item.status}
                    </div>
                </td>
                {property.haveVal('shipped_date') ? (
                    <td>
                        {item && item.shipped_date
                            ? moment(item.shipped_date).format(`YYYY-MM-DD`)
                            : '-'}
                    </td>
                ) : (
                    ''
                )}
                <td style={{ whitespace: 'nowrap' }}>
                    {I18n.formatCurrency(
                        Helper.formatPrice(
                            item.base_price,
                            seller && seller.currency_code,
                        ),
                    )}
                </td>
                <td style={{ whitespace: 'nowrap' }}>
                    {I18n.formatCurrency(
                        Helper.formatPrice(
                            item.total_fees,
                            seller && seller.currency_code,
                        ),
                    )}
                </td>
                <td style={{ whitespace: 'nowrap' }}>
                    {I18n.formatCurrency(
                        Helper.formatPrice(
                            item.net_due,
                            seller && seller.currency_code,
                        ),
                    )}
                </td>
                <td>
                    <div>
                        {I18n.formatCurrency(
                            Helper.formatPrice(
                                item.net_paid,
                                seller && seller.currency_code,
                            ),
                        )}
                        <div>
                            <LocaleLink
                                to={`/sales/${item.item_nr}`}
                                className={styles.viewMoreBtn}
                            >
                                {I18n.getText('sales.view-more')}
                            </LocaleLink>
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/sales/salesTable/salesRow/SalesRow.js